import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

interface CreditBalance {
  credits_available: number;
  credits_pending: number;
}

export function useParentCredits(ptaId?: string) {
  const { user } = useAuth();
  const [balance, setBalance] = useState<CreditBalance | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !ptaId) {
      setLoading(false);
      return;
    }

    fetchBalance();
  }, [user, ptaId]);

  const fetchBalance = async () => {
    if (!user || !ptaId) return;

    setLoading(true);
    
    // Get parent ID first
    const { data: parentData } = await supabase
      .from('parents')
      .select('id')
      .eq('user_id', user.id)
      .eq('pta_id', ptaId)
      .single();

    if (!parentData) {
      setLoading(false);
      return;
    }

    // Get credit balance
    const { data, error } = await supabase
      .from('parent_credits')
      .select('credits_available, credits_pending')
      .eq('parent_id', parentData.id)
      .eq('pta_id', ptaId)
      .single();

    if (error && error.code !== 'PGRST116') { // Ignore "not found" errors
      console.error('Error fetching credits:', error);
    } else if (data) {
      setBalance(data);
    } else {
      setBalance({ credits_available: 0, credits_pending: 0 });
    }

    setLoading(false);
  };

  return {
    balance,
    loading,
    refetch: fetchBalance
  };
}
